/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const CreateCustomerBody = zod.object({
  name: zod.string(),
});

export type CreateCustomerBody = zod.input<typeof CreateCustomerBody>;
export type CreateCustomerBodyOutput = zod.output<typeof CreateCustomerBody>;
